import React, { Component } from "react";
import styles from "./userUnitBar.module.scss";
import SideBar from "../../../sides/sideBar";
import CarsTitleClosedBar from "../../../sections/cars/carsTitleClosedBar";
import SideBarInner from "../../../../shared/sideBarInner";
import CarsSortPanel from "../../../sections/cars/carsSortPanel";
import CarsPaginationSettingsPanel from "../../../sections/cars/carsPaginationSettingsPanel";
import CarsSecondSideBar from "../../../sections/secondSideBars/carsSecondSideBar";
import CarsTitleBar from "../../../sections/cars/carsTitleBar";
import UserUnitListWrapper from "./UserUnitListWrapper";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { withUsers } from "../../../../shared/containers/containerUsers";
import { withUnits } from "../../../../shared/containers/containerUnits";
import { withCars } from "../../../../shared/containers/containerCars";
import { states } from "../../../../reducers/queriesStates";

class UserUnitsBar extends Component {
  constructor(props) {
    super(props);

    this.state = { isCheck: false, toAction: [], actionDelete: false };
  }

  componentDidUpdate(preProps) {
    const { currentUser, listUnits, createUserUnitDataState, deleteUserUnitDataState, onCreateUserUnit, onDeleteUserUnit } = this.props;
    const { isCheck, toAction, actionDelete } = this.state;

    if (toAction.length > 0) {
      if (
        (createUserUnitDataState === states.READY && preProps.createUserUnitDataState === states.REQUEST) ||
        (deleteUserUnitDataState === states.READY && preProps.deleteUserUnitDataState === states.REQUEST)
      ) {
        const _toAction = toAction.slice(1);

        if (_toAction.length > 0) {

          if (actionDelete) onDeleteUserUnit(currentUser, _toAction[0]);
          else onCreateUserUnit(currentUser, _toAction[0]);
        }

        this.setState({ toAction: _toAction });
      }
    }

    let _isCheck = true;

    listUnits.forEach((unit) => {
      if (_isCheck) {
        _isCheck = currentUser.units.some((x) => {
          return x.id === unit.id;
        });
      }
    });

    if (isCheck !== _isCheck) {
      this.setState({ isCheck: _isCheck });
    }
  }

  onClickHandler() {
    const { currentUser, listUnits, onDeleteUserUnit, onCreateUserUnit } = this.props;
    const { isCheck } = this.state;
    const toAction = [];

    listUnits.forEach((unit) => {
      const _isCheck = currentUser.units.some((x) => {
        return x.id === unit.id;
      });

      if (_isCheck === isCheck) {
        toAction.push(unit);
      }
    });

    if (toAction.length > 0) {
      if (isCheck) onDeleteUserUnit(currentUser, toAction[0]);
      else onCreateUserUnit(currentUser, toAction[0]);
      this.setState({ toAction, actionDelete: isCheck });
    }
  }

  render() {
    const { currentUser } = this.props;
    const { isCheck, toAction } = this.state;

    return (
      <div className={styles.sideBarsWrapper}>
        <SideBar TitleClosed={<CarsTitleClosedBar />}>
          <div className={styles.userUnitsBar}>
            <SideBarInner>
              <CarsTitleBar />
            </SideBarInner>

            <SideBarInner>
              <CarsSortPanel />
            </SideBarInner>

            <SideBarInner>
              <div className={styles.inLineContainer}>
                <CarsPaginationSettingsPanel />
                <div
                  className={styles.container_params}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (toAction.length === 0) {
                      this.onClickHandler();
                    }
                  }}
                >
                  {currentUser.role.roleType === 500 ? (
                    <TooltipWrapper title={isCheck ? "Убрать все" : "Выбрать все"} position="top">
                      <div className={styles.inLineRightContainer}>
                        {isCheck ? (
                          <div className={styles.container_itemChecked}>
                            <CheckCircleIcon fontSize="small" />
                          </div>
                        ) : (
                          <div className={styles.container_itemUnchecked}>
                            <CheckCircleOutlineIcon fontSize="small" />
                          </div>
                        )}
                      </div>
                    </TooltipWrapper>
                  ) : null}
                </div>
              </div>

              <div className={styles.container_userUnitsList}>
                <UserUnitListWrapper />
              </div>
            </SideBarInner>
          </div>
        </SideBar>

        <CarsSecondSideBar />
      </div>
    );
  }
}

export default withCars(withUsers(withUnits(React.memo(UserUnitsBar))));
